import { render, staticRenderFns } from "./TheTownSelect.vue?vue&type=template&id=6b6acd31&scoped=true&"
import script from "./TheTownSelect.vue?vue&type=script&lang=ts&"
export * from "./TheTownSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TheTownSelect.vue?vue&type=style&index=0&id=6b6acd31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6acd31",
  null
  
)

export default component.exports